// Add your custom JS here.
(function ($) {
    // Fade in effects
    AOS.init();

    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,
    });

    var swiper = new Swiper(".topbar-swiper", {
        direction: "vertical",
        loop: true,
        autoplay: {
            delay: 2000,
        },

        breakpoints: {
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 1,
            },
        },
    });

    var swiper = new Swiper(".title-swiper", {
        direction: "vertical",
        loop: true,
        autoplay: {
            delay: 2000,
        },

        breakpoints: {
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 1,
            },
        },
    });

    var swiper = new Swiper(".text-swiper", {
        direction: "horizontal",
        loop: true,
        autoplay: {
            delay: 2000,
        },
        spaceBetween: 40,
        slidesPerView: 1,

        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1450: {
                slidesPerView: 4,
            },
        },
    });

    var swiper = new Swiper(".quote-swiper-component", {
        // Optional parameters
        direction: "horizontal",
        loop: false,
        effect: "fade",

        // If we need pagination
        pagination: {
            el: ".swiper-pagination",
        },

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

        // And if we need scrollbar
        scrollbar: {
            el: ".swiper-scrollbar",
        },
    });

    //FADE effects for components

    //CTA-bottom-component

    // $(".section-cta-bottom-component .left,.right").on(
    //     "mouseover",
    //     function () {
    //         //and add display flex to the button
    //         $(this).find(".content-wrapper .button").fadeToggle(3500);
    //         // $(this).find(".content-wrapper .button").css("display", "flex");
    //     }
    // );

    //make first tab-title active

    $(".tab-title").first().addClass("active");
    $(".tab-button-up").addClass("disabled");

    function activateTab(index) {
        // Remove active class from all tab-titles and tabs
        $(".tab-title").removeClass("active");
        $("._tab").removeClass("active");

        // Add active class to the tab-title and the corresponding tab with the given index
        $('.tab-title[data-index="' + index + '"]').addClass("active");
        $('._tab[data-index="' + index + '"]').addClass("active");

        if ($(".tab-title").first().hasClass("active")) {
            $(".tab-button-up").addClass("disabled");
        } else {
            $(".tab-button-up").removeClass("disabled");
        }

        if ($(".tab-title").last().hasClass("active")) {
            $(".tab-button-down").addClass("disabled");
        } else {
            $(".tab-button-down").removeClass("disabled");
        }
    }

    // Disable the up button if the first tab has class active

    $(".tab-title").on("click", function () {
        var index = $(this).data("index");
        activateTab(index);
    });

    $(".tab-button-up").on("click", function () {
        var currentIndex = $(".tab-title.active").data("index");
        var newIndex = currentIndex - 1;
        if (newIndex >= 1) {
            activateTab(newIndex);
        }
    });

    $(".tab-button-down").on("click", function () {
        var currentIndex = $(".tab-title.active").data("index");
        var newIndex = currentIndex + 1;
        if (newIndex <= $(".tab-title").length) {
            activateTab(newIndex);
        }
    });

    //if tab is the last tab or the first tab, disable the button
    $(".tab-button-up").on("click", function () {
        var currentIndex = $(".tab-title.active").data("index");
        var newIndex = currentIndex;
        if (newIndex == 1) {
            $(".tab-button-up").addClass("disabled");
        } else {
            $(".tab-button-up").removeClass("disabled");
        }
    });

    $(".questions").on("click", function () {
        $(this).find(".answer").slideToggle();
        $(this).find(".question").toggleClass("active");
    });

    $(".section-tab-with-image-component .tab-wrapper .tab").on(
        "click",
        function () {
            $(
                ".section-tab-with-image-component .tab-wrapper .tab"
            ).removeClass("active");
            $(this).addClass("active");

            //make the right-wrapper tab-content active with the same data-index as the clicked tab
            var index = $(this).data("index");
            $(".tab-content").removeClass("active");
            $(".tab-content[data-index=" + index + "]").addClass("active");
        }
    );

    //make the first tab active
    $(".section-tab-with-image-component .tab-wrapper .tab").first().click();

    if ($(window).width() < 992) {
        $(".menu-wrapper").addClass("active");
        $("li.menu-item-has-children").on("click", function () {
            $(this).find(".sub-menu").slideToggle("fast");
            $(this).toggleClass("active");
            $(this).find(".sub-menu").addClass("active");
        });
    }

    $(".hamburger").on("click", function () {
        $(this).toggleClass("active");

        $(".button-wrapper-mobile").fadeToggle();
        //give display flex to buttn-wrapper-mobile on toggle
        $(".button-wrapper-mobile").css("display", "flex");

        $(".menu-wrapper").fadeToggle();
    });

    //if screen width is greater than 1024px, remove the active class from the menu-wrapper

    if ($(window).width() < 992) {
        $(".mobile-sidebar-toggle").on("click", function () {
            $(".backdrop-overlay").fadeToggle();
            $(".sidebar").fadeToggle();
            $(".mobile-sidebar-close").addClass("active");
        });
    }

    $(".mobile-sidebar-close").on("click", function () {
        $(".backdrop-overlay").fadeOut();
        $(".sidebar").fadeOut();
        $(".mobile-sidebar-close").removeClass("active");
    });

    $(".backdrop-overlay").on("click", function () {
        $(".backdrop-overlay").fadeOut();
        $(".sidebar").fadeOut();
        $(".mobile-sidebar-close").removeClass("active");
    });

    //hide the .mobile-side-bar-toggle if footer is reached with offset

    if ($(window).width() < 992) {
        $(window).scroll(function () {
            if (
                $(window).scrollTop() + $(window).height() + 1000 >=
                $(document).height()
            ) {
                $(".mobile-sidebar-toggle").fadeOut();
            } else {
                $(".mobile-sidebar-toggle").fadeIn();
            }
        });
    }

    //if screen width is greater than 1024px, remove the active class from the menu-wrapper

    // var authors = $("#typewriter .word")
    //     .map(function () {
    //         return this.innerText;
    //     })
    //     .get();

    // const typewriter = document.querySelector("#typewriter");
    // tinyTypewriter(typewriter, {
    //     items: authors,
    // });
})(jQuery);
